module.exports = __webpack_public_path__ + "img/result_txt_s.106551a6.png";